/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_UpcomingInputs */

const en_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const es_status_upcoming = /** @type {(inputs: Status_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proximo`)
};

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Status_UpcomingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_upcoming = /** @type {((inputs?: Status_UpcomingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_UpcomingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_upcoming(inputs)
	return es_status_upcoming(inputs)
});